import { render } from "./NewVacation.vue?vue&type=template&id=260e1d58&scoped=true"
import script from "./NewVacation.vue?vue&type=script&lang=js"
export * from "./NewVacation.vue?vue&type=script&lang=js"

import "./NewVacation.vue?vue&type=style&index=0&id=260e1d58&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260e1d58"]])

export default __exports__